import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'

export const astApi = {
	sendProcurementPlan: async () => {
		const res = await axiosDS().get(`${urls.pp.ast.load_plan_info}`)
		return res.data
	},
}
